var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      key: _vm.updateComponent,
      attrs: {
        row: "",
        "align-start": "",
        "justify-space-between": "",
        wrap: ""
      }
    },
    [
      !_vm.editingData
        ? _c(
            "div",
            { staticClass: "specific-fields-view-container" },
            _vm._l(_vm.fields, function(field) {
              return _c(
                "div",
                {
                  key: field.varName,
                  staticClass: "specific-field-view-container",
                  class: { "show-lines": !_vm.hideLines }
                },
                [
                  field.icon
                    ? _c("v-icon", [_vm._v(_vm._s(field.icon))])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(field.label) + ": ")]),
                  _c("span", [_vm._v(_vm._s(field.value))])
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.editingData
        ? _c(
            "div",
            { staticClass: "card-info" },
            _vm._l(_vm.fields, function(field) {
              return _c(
                "div",
                {
                  key: field.label + " - " + field.varName,
                  staticClass: "card-info-item-container",
                  style: [{ width: field.size ? field.size : 100 / 3 + "%" }]
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card-info-item",
                      style: _vm.cardInfoItemStyling
                    },
                    [
                      _c("input-field", {
                        key: field.varName,
                        attrs: {
                          inputType: field.inputType,
                          value: field.value,
                          label: field.label,
                          "input-disabled": field.disabled,
                          "select-options": field.optionsListName,
                          "select-options-list": field.options,
                          "checkbox-options": field.checkboxOptions,
                          "radio-options": field.radioOptions,
                          min: field.min,
                          max: field.max,
                          step: field.step,
                          size: "large",
                          clearable: field.clearable,
                          required: field.required,
                          inputFieldContainerStyling: { padding: "0" },
                          "checkbox-icon-style": field.checkboxIconStyle,
                          placeholder: field.placeholder
                        },
                        on: {
                          input: function($event) {
                            return _vm.$emit("update-field", {
                              value: $event,
                              field: field
                            })
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            }),
            0
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d2b49bf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d2b49bf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/StockManagement/FieldsList.vue
// module id = null
// module chunks = 